import request, { slugValidateRequest } from '../request';
import { isObject, isBoolean } from '../helpers';

/**
 * Network request with appropriate headers for the JSON API
 *
 * @param  {string} uri    A URI to a requested resource
 * @param  {object} [opts] Additional options for body and HTTP method
 *
 * @return {function}    Call to `request/2`
 */
export const unauthedRequest =
  (uri, opts = {}) =>
    request(uri, {
      headers: {
        'Accept': 'application/vnd.mvbth.v1+json',
        'Content-Type': 'application/json',
      },
      ...opts,
    });

/**
 * Network request with appropriate headers for the JSON API
 *
 * @param  {string} uri       A URI to a requested resource
 * @param  {string} authToken A token used by the API to id requestor
 * @param  {object} [opts]    Additional options for body and HTTP method
 *
 * @return {function}         Call to `request/2`
 */
export const authedRequest =
  (uri, authToken, opts = {}) =>
    request(uri, {
      headers: {
        'Accept': 'application/vnd.mvbth.v2+json',
        'Content-Type': 'application/json',
        'Authorization': `Token token=${authToken}`,
      },
      ...opts,
    });

    export const authedSlugValidationRequest =
  (uri, authToken, opts = {}) =>
    slugValidateRequest(uri, {
      headers: {
        'Accept': 'application/vnd.mvbth.v2+json',
        'Content-Type': 'application/json',
        'Authorization': `Token token=${authToken}`,
      },
      ...opts,
    });

export const authedFormRequest =
  (uri, authToken, opts = {}) =>
    request(uri, {
      headers: {
        'Accept': 'application/vnd.mvbth.v1+json',
        'Authorization': `Token token=${authToken}`,
      },
      ...opts,
    });

export const setFormData = (parent, obj = {}) => {
  let data = new FormData();

  Object.keys(obj).map((key) =>
    obj[key] && data.append(`${parent}[${key}]`, obj[key])
  );

  return data;
}

export const objectToFormData = (params) => {
  let data = new FormData();
  const setFormData = (parent, obj = {}) => {
    if (obj instanceof File) {
      data.append(parent, obj);
    } else if (isObject(obj)) {
      Object.keys(obj).map((key) => {
        const objValue = obj[key];
        const objKey = `${parent}[${key}]`;
        if (objValue) {
          if (isObject(objValue)) {
            setFormData(objKey, objValue);
          } else {
            data.append(objKey, objValue);
          }
        } else if (objValue == "" || isBoolean(objValue)) {
          data.append(objKey, objValue);
        }
      });
    } else if (obj || obj == "" || isBoolean(obj)) {
      data.append(parent, obj);
    }
  };

  Object.keys(params).map((k) => setFormData(k, params[k]));

  return data;
};



// WEBPACK FOOTER //
// ./src/utils/api/requests.js